<template>
    <div>
				<div class="toolbar" ref="title">
            {{title}}
				</div>
        <div class="message-area">
            <div class="message-block">
                <div id="preview-area" v-html="compiledMarkdown"></div>
            </div>
            <div class="message-button-block">
                <button @click="closeDialog()">Close</button>
            </div>
				</div>
		</div>    
</template>

<script>

import { marked } from 'marked';
import { gfmHeadingId } from 'marked-gfm-heading-id';

marked.use(gfmHeadingId({prefix: 'my-prefix-'}))

export default {
    name: 'markdown-message-dialog',
    props: ["title", "message", "color"],
    data() {
        return {}
    },
    mounted() {
			this.$refs.title.style['background-color'] = this.color;
		},
    computed: {
        compiledMarkdown() {
            return marked(this.message, { sanitize: true });
        }
    },
    methods: {
        closeDialog() {
            this.$emit('close-dialog')
        }
    }
}
</script>

<style scoped>
    .message-block {
			font-family: "Helvetica Neue", Arial, sans-serif!important;
        font-size: 14pt;
    }

    .message-button-block {
			font-family: "Helvetica Neue", Arial, sans-serif!important;
        text-align: center;
        margin-bottom: 5px;
				font-size: 14px;
				font-weight: 200;
    }

		.message-area {
			font-family: "Helvetica Neue", Arial, sans-serif!important;
			padding: 10px;
		}

		.toolbar {
			font-family: "Open Sans", sans-serif!important;
			background-color: darkgray;
			color: black;
			padding: 5px;
			font-weight: 400;
			width: 600px;
		}

    #preview-area {
			display: inline-block;
			font-family: "Open Sans", sans-serif!important;
			line-height: 1.2;
			font-size: 14px;
			outline: none;
			padding: 5px;
			user-select: none;
			overflow-y: auto;
			width: 100%;
    }
</style>